 /*! RZC – Lorcana V2 (port PKM) */
(function () {
 
  if (window.__RZC_LOR_COLLECTION_V2__) return;
  window.__RZC_LOR_COLLECTION_V2__ = true;

  const root = document.getElementById("rzc-lor");
  if (!root) return;

  const seriesHandle = root.dataset.lzSeriesHandle || "";
  const universe = root.dataset.lzUniverse || "lor";
  const customerEmail = root.dataset.lzCustomerEmail || "";
  const loginUrl = root.dataset.lzLoginUrl || "/account/login";
  const normalizedEmail = (customerEmail || "").trim().toLowerCase();
  const isLoggedIn = !!normalizedEmail;

  // =======================================================
  // AJAX ADD TO CART (unitaire + batch)
  // =======================================================
  root.addEventListener('submit', async (e) => {
    const form = e.target.closest('.rzc-var-form');
    if (!form || !root.contains(form)) return;
    e.preventDefault();

    const btn = form.querySelector('.rzc-var-btn');
    if (btn && btn.classList.contains('is-disabled')) {
        showToast("❌ Non Disponible", true);
        return;
    }

    if(btn) btn.classList.add('is-loading');

    const formData = new FormData(form);
    const items = [{
        id: formData.get('id'),
        quantity: 1
    }];

    try {
        await addBatch(items);
        showToast("✅ Ajouté au panier");
        await refreshCartCount();
    } catch (err) {
        showToast("Erreur d'ajout", true);
        console.error(err);
    } finally {
        if(btn) btn.classList.remove('is-loading');
    }
  });

  async function addBatch(items) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept":"application/json" },
      body: JSON.stringify({ items })
    });
    if (!res.ok) throw new Error("Erreur");
  }
  async function refreshCartCount() {
    try {
      const r = await fetch("/cart.js", { headers:{ "Accept":"application/json" }});
      const c = await r.json();
      document.querySelectorAll("[data-cart-count], .cart-count-bubble, #CartCount, .site-header__cart-count")
        .forEach(e => { if(e) e.textContent = c.item_count; });
      document.dispatchEvent(new CustomEvent("cart:updated", { detail:{ cart:c }}));
    } catch(e){}
  }

  // =======================================================
  // STATE + PERSISTENCE via Edge Function lz-api
  // (plus d'accès direct à Supabase — voir assets/lz-api-client.js)
  // =======================================================
  let lzOwnedFromSupabase = new Set();
  let lzOwnedVariantsFromSupabase = new Set();

  async function loadOwnedFromSupabase() {
    if (!normalizedEmail) {
      updateAllStats();
      return;
    }
    if (!window.lzApi) {
      console.warn("[RZC LOR] window.lzApi non disponible — tracking désactivé.");
      updateAllStats();
      return;
    }
    try {
      const res = await window.lzApi.collectionLoad({ email: normalizedEmail, universe });
      if (!res.ok) {
        console.error("[RZC LOR] collectionLoad error:", res);
        updateAllStats();
        return;
      }

      lzOwnedFromSupabase       = new Set(res.data.products || []);
      lzOwnedVariantsFromSupabase = new Set(res.data.variants || []);

      root.querySelectorAll(".rzc-item.lz-collection-item").forEach(item => {
        const pid = String(item.dataset.productId || "");
        if (lzOwnedFromSupabase.has(pid)) {
          item.classList.add("lz-owned");
          const pt = getPrimaryVariantToggle(item);
          if (pt) {
            pt.dataset.owned = "true";
            pt.textContent = "✅";
            syncPrimaryMainVariantButton(item, true);
          }
        }
      });

      root.querySelectorAll(".lz-var-toggle-owned").forEach(btn => {
        if (lzOwnedVariantsFromSupabase.has(String(btn.dataset.variantId))) {
          btn.dataset.owned = "true";
          btn.textContent = "✅";
          const form = btn.closest(".rzc-var-form");
          if (form) form.querySelector(".rzc-var-btn")?.classList.add("lz-var-owned");
        }
      });

      updateAllStats();
      syncFabTogglesFromPanel();
    } catch (e) {
      console.error("[RZC LOR] loadOwnedFromSupabase exception:", e);
      updateAllStats();
    }
  }

  const bootOwned = async () => {
    await loadOwnedFromSupabase();

    if (isLoggedIn) {
      updateAllStats();
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootOwned);
  } else {
    bootOwned();
  }

  async function persistOwnedState(pid, owned, title) {
    if (!normalizedEmail || !window.lzApi) return;
    const res = await window.lzApi.toggleProduct({
      email: normalizedEmail,
      universe,
      productId: String(pid),
      owned,
      seriesHandle,
      productTitle: title || "",
    });
    if (!res.ok) console.error("[RZC LOR] toggleProduct error:", res);
  }

  async function persistVariantOwnedState(vid, owned, pid, ptitle, kind) {
    if (!normalizedEmail || !window.lzApi) return;
    const res = await window.lzApi.toggleVariant({
      email: normalizedEmail,
      universe,
      variantId: String(vid),
      owned,
      variantKind: kind || "",
      seriesHandle,
      productTitle: ptitle || "",
    });
    if (!res.ok) console.error("[RZC LOR] toggleVariant error:", res);
  }

  async function syncSeriesProgressToSupabase(g, f) {
    if (!normalizedEmail || !seriesHandle || !window.lzApi) return;
    const res = await window.lzApi.syncProgress({
      email: normalizedEmail,
      universe,
      seriesHandle,
      seriesTitle: document.title,
      totalCards: g.total,
      ownedCards: g.owned,
      totalReverseCards: f.total, // on réutilise les colonnes reverse pour foil
      ownedReverseCards: f.owned,
    });
    if (!res.ok) console.error("[RZC LOR] syncProgress error:", res);
  }

  // =======================================================
  // HELPERS UI
  // =======================================================
  function showToast(text, isError) {
    const el = root.querySelector(".rzc-toast");
    if (!el) return;
    el.classList.toggle("is-error", !!isError);
    el.textContent = text; 
    el.style.display = "block";
    clearTimeout(showToast.timer);
    showToast.timer = setTimeout(() => { el.style.display = "none"; }, 1800);
  }

  const variantToItem = new Map();
  const variantPrices = new Map();
  const allItems = Array.from(root.querySelectorAll(".rzc-item"));
  const collectionItems = Array.from(root.querySelectorAll(".lz-collection-item"));
  let filterPill = null;

  function getVariantKindForId(li, id) {
    const tgl = li.querySelector(`.lz-var-toggle-owned[data-variant-id="${id}"]`);
    return tgl?.dataset.kind || "normal";
  }
  function getPrimaryVariantToggle(li) {
    return li.querySelector('.lz-var-toggle-owned[data-kind="normal"]') || li.querySelector(".lz-var-toggle-owned");
  }
  function syncPrimaryMainVariantButton(li, owned) {
    const tgl = getPrimaryVariantToggle(li);
    if(tgl) {
      const vid=tgl.dataset.variantId;
      const btn=li.querySelector(`.rzc-var-form input[value="${vid}"]`)?.closest("form")?.querySelector(".rzc-var-btn");
      if(btn) btn.classList.toggle("lz-var-owned", owned);
    }
  }
function isCardFullyOwned(li) {
  if(!li.classList.contains("lz-owned")) return false;

  for (const b of li.querySelectorAll(".lz-var-toggle-owned")) {
    const k = b.dataset.kind || "normal";

    // ✅ base Lorcana = normal uniquement
    if (k !== "normal" && b.dataset.owned !== "true") {
      return false;
    }
  }
  return true;
}

  function syncFullyOwnedUI(li) {
    li.classList.toggle("lz-fully-owned", isCardFullyOwned(li));
  }

  // map variants → li + prices
  allItems.forEach(li => {
    li.querySelectorAll(".rzc-var-form").forEach(f => {
      const id = parseInt(f.querySelector('input[name="id"]')?.value, 10);
      if(id) {
        const p=f.querySelector(".rzc-var-price")?.textContent.replace(/[^\d,\.]/g,"").replace(",",".");
        if(p) variantPrices.set(id, parseFloat(p));
        variantToItem.set(id, li);
      }
    });
  });

  // =======================================================
  // PILLS (recompute comme PKM)
  // =======================================================
  const bulkPills = Array.from(root.querySelectorAll(".rzc-bulk"));
  bulkPills.forEach(p => p._fullIds = (p.dataset.ids||"").split(",").map(Number).filter(n=>n));

  function recomputeBulkPills() {
    bulkPills.forEach(pill => {
      const allIds = pill._fullIds || [];
      const missingIds = allIds.filter(id => {
        const li = variantToItem.get(id);
        if(!li) return true;

        // pill foil = check variante foil possédée
        if(pill.classList.contains("is-foil")) {
          return !li.querySelector('.lz-var-toggle-owned[data-kind="foil"][data-owned="true"]');
        }

// pill all = check possession selon kind (port PKM)
if (pill.classList.contains("is-all")) {
  const k = getVariantKindForId(li, id);

  // ✅ Toute variante non-normal doit être possédée
  if (k !== "normal") {
    return !li.querySelector(`.lz-var-toggle-owned[data-variant-id="${id}"][data-owned="true"]`);
  }
}

        return !li.classList.contains("lz-owned");
      });

      if(!missingIds.length) {
        pill.style.display="none";
        pill.classList.remove("is-open");
        removeControls(pill);
      } else {
        pill.style.display="";
        pill.dataset.ids = missingIds.join(",");
        const tot = missingIds.reduce((s,i) => s + (variantPrices.get(i)||0), 0);
        const meta = pill.querySelector(".rzc-bulk-meta");
        if(meta) meta.textContent = `${missingIds.length} Cartes • ${tot.toFixed(2).replace(".",",")}€`;
      }
    });
  }

  function injectControls(pill) {
    if(pill.querySelector(".rzc-controls")) return;
    const d = document.createElement("div");
    d.className = "rzc-controls";
    d.innerHTML = `<button type="button" class="rzc-ctrl" data-action="cart">Panier</button>
                   <button type="button" class="rzc-ctrl" data-action="filter">Filtrer</button>`;
    pill.appendChild(d);
  }
  function removeControls(pill) {
    pill.querySelector(".rzc-controls")?.remove();
  }
  function applyFilterForPill(pill) {
    const ids = new Set((pill.dataset.ids||"").split(",").map(Number));
    allItems.forEach(li => {
      let match = false;
      li.querySelectorAll('input[name="id"]').forEach(inp => {
        if(ids.has(parseInt(inp.value))) match=true;
      });
      li.classList.toggle("is-filter-pill", !match);
    });
    filterPill = pill;
    updateFilterModes();
  }

  // =======================================================
  // STATS (global + foil)
  // =======================================================
  const fabProgress = document.getElementById("lz-fab-progress");
  const totalFoilCards = parseInt(fabProgress?.dataset.countFoil || 0, 10);

  function computeCollectionStats() {
    const total = allItems.length;
    let owned = 0, avail = 0;
    allItems.forEach(li => {
      if(li.classList.contains("lz-owned")) owned++;
      else if(li.querySelector(".rzc-var-btn:not(.is-disabled)")) avail++;
    });
    return {
      total, owned, avail,
      pct: total?Math.round((owned/total)*100):0,
      pot: total?Math.round(((owned+avail)/total)*100):0
    };
  }

  function computeFoilStats() {
    let owned=0, avail=0;
    allItems.forEach(li => {
      const foils = Array.from(li.querySelectorAll('.lz-var-toggle-owned[data-kind="foil"]'));
      if(foils.length) {
        const isOwned = foils.some(r=>r.dataset.owned==="true");
        if(isOwned) owned++;
        else {
          const isAvail = foils.some(r => {
            const vid = r.dataset.variantId;
            const btn = li.querySelector(`.rzc-var-form input[value="${vid}"]`)?.closest("form")?.querySelector(".rzc-var-btn");
            return btn && !btn.classList.contains("is-disabled");
          });
          if(isAvail) avail++;
        }
      }
    });
    return {
      total: totalFoilCards,
      owned,
      pct: totalFoilCards?Math.round((owned/totalFoilCards)*100):0,
      pot: totalFoilCards?Math.round(((owned+avail)/totalFoilCards)*100):0
    };
  }

  function renderCollectionStats(stats) {
    const g = stats || computeCollectionStats();
    const wrap = fabProgress;
    if(!wrap) return;

    const target = wrap.querySelector('.lz-collection-progress-inner:not(.lz-collection-progress-inner-foil)');
    if(!target) return;

    target.querySelector(".lz-collection-progress-count").textContent = `${g.owned} / ${g.total}`;
    target.querySelector(".lz-collection-progress-percent").textContent = `${g.pct}%`;
    target.querySelector(".lz-collection-progress-fill").style.width = `${g.pct}%`;

    const dispo = root.querySelector(".lz-available-switch")?.dataset.on === "1";
    target.querySelector(".lz-collection-progress-fill-available").style.width = dispo ? `${g.pot}%` : "0%";
  }

  function renderFoilStats(stats) {
    const f = stats || computeFoilStats();
    const wrap = fabProgress;
    if(!wrap) return;

    const target = wrap.querySelector(".lz-collection-progress-inner-foil");
    if(!target) return;

    target.querySelector(".lz-collection-progress-count-foil").textContent = `${f.owned} / ${f.total}`;
    target.querySelector(".lz-collection-progress-percent-foil").textContent = `${f.pct}%`;
    target.querySelector(".lz-collection-progress-fill-foil").style.width = `${f.pct}%`;

    const dispo = root.querySelector(".lz-available-switch")?.dataset.on === "1";
    target.querySelector(".lz-collection-progress-fill-available-foil").style.width = dispo ? `${f.pot}%` : "0%";
  }

  function updateAllStats() {
    const g = computeCollectionStats();
    const f = computeFoilStats();

    renderCollectionStats(g);
    renderFoilStats(f);
    recomputeBulkPills();
    updateFilterModes();

    syncSeriesProgressToSupabase(g, f);
  }

  function updateFilterModes() {
    const missing = root.querySelector(".lz-missing-switch")?.dataset.on === "1";
    const avail = root.querySelector(".lz-available-switch")?.dataset.on === "1";

    collectionItems.forEach(li => {
      let hide = li.classList.contains("is-filter-pill");
      if(missing && isCardFullyOwned(li)) hide = true;
      if(avail && !li.querySelector(".rzc-var-btn:not(.is-disabled)")) hide = true;
      li.classList.toggle("is-filter-mode", hide);
    });

    root.classList.toggle("has-filter", allItems.some(li => li.classList.contains("is-filter-mode")));
  }

  // =======================================================
  // Profil bouton : si pas loggé → login
  // =======================================================
  const profileBtn = document.querySelector(".lz-profile-btn");
  if (profileBtn) {
    profileBtn.addEventListener("click", (ev) => {
      if (!isLoggedIn) {
        ev.preventDefault();
        showToast("Connecte-toi !");
        window.location.href = loginUrl;
      }
    });
  }

  // =======================================================
  // FAB OPEN/CLOSE helper (sans toast) – mirror PKM
  // =======================================================
  const fabProgressPanel = document.getElementById("lz-fab-progress");
  function setFabOpen(isOpen){
    root.classList.toggle("lz-fab-open", !!isOpen);
    if (fabProgressPanel){
      fabProgressPanel.setAttribute("aria-hidden", isOpen ? "false" : "true");
    }
    if (isOpen) root.classList.remove("lz-filter-open");
    if (window.innerWidth < 768) {
      const crisp = document.querySelector(".crisp-client");
      if (crisp) crisp.style.display = isOpen ? "none" : "";
    }
  }

  // =======================================================
  // FAB Trigger
  // =======================================================
  const fabTrigger = document.getElementById("lz-fab-trigger");
  if (fabTrigger) {
    fabTrigger.addEventListener("click", (ev) => {
      ev.preventDefault();
      ev.stopPropagation();

      if (!isLoggedIn) {
        showToast("Connecte-toi !");
        window.location.href = loginUrl;
        return;
      }

      const menuOpen = root.classList.contains("lz-fab-open");
      setFabOpen(!menuOpen); // ✅ toggle normal

      updateAllStats();
    });
  }

  const fabClose = document.getElementById("lz-fab-close");
  if (fabClose) {
    fabClose.addEventListener("click", (ev) => {
      ev.preventDefault();
      setFabOpen(false);
    });
  }

  // =======================================================
  // PANEL FILTRES (port OP)
  // =======================================================
  const filterTrigger = document.getElementById("lz-filter-trigger");
  const filterClose = document.getElementById("lz-filter-close");
  const filterReset = document.getElementById("lz-filter-reset");
  const filterPills = root.querySelectorAll(".lz-filter-pill");

  function setFilterOpen(isOpen) {
    root.classList.toggle("lz-filter-open", !!isOpen);
    const panel = document.getElementById("lz-filter-panel");
    if (panel) panel.setAttribute("aria-hidden", isOpen ? "false" : "true");
    if (isOpen) setFabOpen(false);
  }

  if (filterTrigger) {
    filterTrigger.addEventListener("click", (ev) => {
      ev.preventDefault();
      setFilterOpen(!root.classList.contains("lz-filter-open"));
    });
  }

  if (filterClose) {
    filterClose.addEventListener("click", (ev) => {
      ev.preventDefault();
      setFilterOpen(false);
    });
  }

  const FILTER_TYPES = ["rarete", "encre", "type", "licence", "classification", "motcle", "inkable"];

  function applyFilters() {
    const active = {};
    root.querySelectorAll(".lz-filter-pill").forEach((pill) => {
      if (pill.getAttribute("aria-pressed") === "true") {
        const t = pill.dataset.filterType;
        if (!active[t]) active[t] = [];
        active[t].push(pill.dataset.filterValue);
      }
    });

    const types = Object.keys(active);
    const items = root.querySelectorAll(".rzc-item");

    items.forEach((item) => {
      if (types.length === 0) {
        item.classList.remove("lz-filter-hidden");
        return;
      }

      let visible = true;
      for (const t of types) {
        const val = (item.dataset[t] || "").toLowerCase();
        const vals = val.split(",").map((v) => v.trim());
        const match = active[t].some((f) => vals.includes(f));
        if (!match) { visible = false; break; }
      }

      item.classList.toggle("lz-filter-hidden", !visible);
    });

    // Mise a jour des badges de comptage par section
    FILTER_TYPES.forEach((t) => {
      const count = (active[t] || []).length;
      const badge = root.querySelector('.lz-filter-count[data-filter-section="' + t + '"]');
      if (badge) {
        badge.textContent = count;
        badge.classList.toggle("is-active", count > 0);
      }
    });
  }

  function syncFiltersToUrl() {
    const params = new URLSearchParams(window.location.search);
    FILTER_TYPES.forEach((t) => params.delete(t));
    const active = {};
    root.querySelectorAll(".lz-filter-pill").forEach((pill) => {
      if (pill.getAttribute("aria-pressed") === "true") {
        const t = pill.dataset.filterType;
        if (!active[t]) active[t] = [];
        active[t].push(pill.dataset.filterValue);
      }
    });
    Object.entries(active).forEach(([t, vals]) => params.set(t, vals.join(",")));
    const qs = params.toString();
    const url = window.location.pathname + (qs ? "?" + qs : "");
    history.replaceState(null, "", url);
  }

  function restoreFiltersFromUrl() {
    const params = new URLSearchParams(window.location.search);
    let hasFilters = false;
    FILTER_TYPES.forEach((t) => {
      const val = params.get(t);
      if (!val) return;
      const vals = val.split(",").map((v) => v.trim());
      root.querySelectorAll(".lz-filter-pill").forEach((pill) => {
        if (pill.dataset.filterType === t && vals.includes(pill.dataset.filterValue)) {
          pill.setAttribute("aria-pressed", "true");
          hasFilters = true;
        }
      });
    });
    if (hasFilters) {
      applyFilters();
      setFilterOpen(true);
    }
  }

  filterPills.forEach((pill) => {
    pill.addEventListener("click", () => {
      const pressed = pill.getAttribute("aria-pressed") === "true";
      pill.setAttribute("aria-pressed", pressed ? "false" : "true");
      applyFilters();
      syncFiltersToUrl();
    });
  });

  if (filterReset) {
    filterReset.addEventListener("click", () => {
      root.querySelectorAll(".lz-filter-pill").forEach((p) => p.setAttribute("aria-pressed", "false"));
      applyFilters();
      syncFiltersToUrl();
    });
  }

  restoreFiltersFromUrl();

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && root.classList.contains("lz-filter-open")) {
      setFilterOpen(false);
    }
  });

  // =======================================================
  // Sync toggles FAB / base
  // =======================================================
  function syncFabTogglesFromPanel() {
    const fabSwitches = root.querySelectorAll(".lz-fab-switch");
    const baseSwitches = {
      collection: root.querySelector(".lz-collection-switch:not(.lz-fab-switch)"),
      available: root.querySelector(".lz-available-switch:not(.lz-fab-switch)"),
      missing: root.querySelector(".lz-missing-switch:not(.lz-fab-switch)"),
    };

    fabSwitches.forEach(fabSw => {
      const controlType = fabSw.dataset.control;
      const baseSw = baseSwitches[controlType];
      if (baseSw) {
        const isOn = baseSw.dataset.on === "1";
        fabSw.dataset.on = isOn ? "1" : "0";
        fabSw.classList.toggle("is-on", isOn);
        fabSw.closest(".lz-fab-bar-group")?.classList.toggle("is-on", isOn);
      }
    });
  }

  // =======================================================
  // Details toggle (texte sans flèche)
  // =======================================================
  const detailsToggle = root.querySelector('.lz-masterset-toggle-details');
  const detailsDiv = document.getElementById('lz-masterset-details');
  if(detailsToggle && detailsDiv) {
    detailsToggle.addEventListener('click', () => {
      const isHidden = detailsDiv.hidden;
      detailsDiv.hidden = !isHidden;
      detailsToggle.textContent = isHidden ? "Masquer le détail" : "Voir le détail";
    });
  }

  // =======================================================
  // EVENTS (pills, switches, owned toggles)
  // =======================================================
  root.addEventListener("click", async (e) => {

    // clic sur variante disabled
    const disabledBtn = e.target.closest(".rzc-var-btn.is-disabled");
    if (disabledBtn) {
      e.preventDefault();
      e.stopPropagation();
      showToast("❌ Non Disponible", true);
      return;
    }

    // controls pill
    const ctrl = e.target.closest(".rzc-ctrl");
    if(ctrl) {
      e.stopPropagation();
      const pill = ctrl.closest(".rzc-bulk");
      if(!pill) return;

      if(ctrl.dataset.action === "cart") {
        const ids = (pill.dataset.ids||"").split(",").map(Number).filter(n=>n);
        pill.dataset.loading="1";
        pill.insertAdjacentHTML('beforeend', `<div class="rzc-progress-text" style="grid-column:span 2;text-align:center;font-size:11px;">Ajout...</div>`);
        try {
          for(let i=0;i<ids.length;i+=25) {
            await addBatch(ids.slice(i,i+25).map(id=>({id,quantity:1})));
          }
          showToast(`➕ ${ids.length} ajoutés`);
          await refreshCartCount();
        } catch(e){ showToast("Erreur", true); }
        finally {
          pill.dataset.loading="0";
          pill.classList.remove("is-open");
          removeControls(pill);
          pill.querySelector(".rzc-progress-text")?.remove();
          recomputeBulkPills();
        }
      } else if(ctrl.dataset.action === "filter") {
        if(filterPill && filterPill!==pill) {
          filterPill.dataset.filtering="0";
          allItems.forEach(li=>li.classList.remove("is-filter-pill"));
        }
        const on = pill.dataset.filtering==="1";
        pill.dataset.filtering = on ? "0" : "1";
        if(on) allItems.forEach(li=>li.classList.remove("is-filter-pill"));
        else applyFilterForPill(pill);
        updateFilterModes();
      }
      return;
    }

    // open/close pill
    const pill = e.target.closest(".rzc-bulk");
    if(pill && pill.dataset.loading!=="1") {
      const isOpen = pill.classList.contains("is-open");
      root.querySelectorAll(".rzc-bulk.is-open").forEach(o=>{ o.classList.remove("is-open"); removeControls(o); });
      if(!isOpen) { pill.classList.add("is-open"); injectControls(pill); }
    }

    // switches
    const sw = e.target.closest(".lz-collection-switch, .lz-missing-switch, .lz-available-switch");
    if(sw) {
      const isFabSwitch = sw.classList.contains("lz-fab-switch");
      if(!isLoggedIn) { showToast("Connecte-toi !"); window.location.href=loginUrl; return; }

      const on = sw.dataset.on==="1";
      const newState = !on;

      let controlType = sw.dataset.control;
      if (sw.classList.contains("lz-collection-switch")) controlType = 'collection';
      else if (sw.classList.contains("lz-available-switch")) controlType = 'available';
      else if (sw.classList.contains("lz-missing-switch")) controlType = 'missing';

      const baseSwitch = root.querySelector(`.${controlType}-switch:not(.lz-fab-switch)`);
      if (baseSwitch) {
        baseSwitch.dataset.on = newState ? "1" : "0";
        baseSwitch.classList.toggle("is-on", newState);
        baseSwitch.setAttribute("aria-pressed", newState);
      }

      const fabSwitch = root.querySelector(`.lz-fab-switch[data-control="${controlType}"]`);
      if (fabSwitch) {
        fabSwitch.dataset.on = newState ? "1" : "0";
        fabSwitch.classList.toggle("is-on", newState);
        fabSwitch.closest(".lz-fab-bar-group")?.classList.toggle("is-on", newState);
      }

      if(controlType === "collection") {
        root.classList.toggle("lz-mode-collection", newState);
      }

      updateAllStats();
      return;
    }

    // owned toggle variante
    const tglV = e.target.closest(".lz-var-toggle-owned");
    if(tglV) {
      e.preventDefault(); e.stopPropagation();
      if(!isLoggedIn) return window.location.href=loginUrl;

      const li = tglV.closest(".rzc-item");
      const isOwned = tglV.dataset.owned === "true";
      const isConfirm = tglV.dataset.confirmRemove === "1";

      let newOwned = isOwned;

      if (!isOwned) {
        tglV.dataset.owned = "true";
        tglV.dataset.confirmRemove = "0";
        tglV.textContent = "✅";
        newOwned = true;
      } else if (isOwned && !isConfirm) {
        tglV.dataset.confirmRemove = "1";
        tglV.textContent = "➖";
        return;
      } else {
        tglV.dataset.owned = "false";
        tglV.dataset.confirmRemove = "0";
        tglV.textContent = "➕";
        newOwned = false;
      }

      const isPrimary = (tglV === getPrimaryVariantToggle(li));
      if(isPrimary) {
        li.classList.toggle("lz-owned", newOwned);
        persistOwnedState(li.dataset.productId, newOwned, li.dataset.productTitle);
      }

      persistVariantOwnedState( 
        tglV.dataset.variantId,
        newOwned,
        li.dataset.productId,
        li.dataset.productTitle,
        tglV.dataset.kind
      );

      const form = tglV.closest("form");
      if(form) form.querySelector(".rzc-var-btn")?.classList.toggle("lz-var-owned", newOwned);

      updateAllStats();
      syncFullyOwnedUI(li);
    }
  });

})();
